import React, { useState } from "react";
import { toast } from "react-toastify";
import request from "../core/request";
import Header from "./header";
import { getDevAppLink } from "../utils";
const { NODE_ENV } = process.env;

const journeyColors = {
  student: "#4361ee",
  institute: "#2d6a4f",
  corporate: "#e76f51",
  internal: "#7b2cbf",
};

const journeyLabels = {
  student: "Student",
  institute: "Institute",
  corporate: "Corporate",
  internal: "Admin",
};

const AccountSelector = ({ accounts, sessionToken, email, onBack }) => {
  const [selecting, setSelecting] = useState(null);

  const handleSelect = async (account) => {
    setSelecting(account.userId);
    try {
      const { data, status } = await request.post(
        "/user/signin/select-account",
        {
          sessionToken,
          userId: account.userId,
        }
      );

      if (status >= 200 && status < 300) {
        let redirectionLink = data?.data?.redirectLink;
        if (NODE_ENV === "development") {
          const link = getDevAppLink(redirectionLink);
          if (link) redirectionLink = link;
        }
        toast.success("Redirecting...");
        window.open(redirectionLink, "_self");
      } else {
        toast.error(data?.message || "Failed to select account");
        setSelecting(null);
      }
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
      setSelecting(null);
    }
  };

  const getInitials = (account) => {
    const first = account.firstName?.[0] || "";
    const last = account.lastName?.[0] || "";
    return (first + last).toUpperCase() || "?";
  };

  return (
    <div className="auth-page-centered">
      <div className="auth-form-centered">
        <div className="auth-card account-selector-card">
          <div className="auth-logo-centered">
            <Header />
          </div>
            <div className="auth-card-header">
              <h2>Choose an account</h2>
              <p>
                Multiple accounts found for <strong>{email}</strong>
              </p>
            </div>

            <div className="account-list">
              {accounts.map((account) => (
                <button
                  key={account.userId}
                  className={`account-item${
                    selecting === account.userId ? " loading" : ""
                  }`}
                  onClick={() => handleSelect(account)}
                  disabled={selecting !== null}
                >
                  <div
                    className="account-avatar"
                    style={{
                      backgroundColor:
                        journeyColors[account.journey] || "#666",
                    }}
                  >
                    {account.profilePicture ? (
                      <img
                        src={account.profilePicture}
                        alt=""
                        className="account-avatar-img"
                      />
                    ) : (
                      getInitials(account)
                    )}
                  </div>
                  <div className="account-details">
                    <div className="account-name">
                      {account.firstName} {account.lastName}
                    </div>
                    <div className="account-role">
                      {account.roleName ||
                        journeyLabels[account.journey] ||
                        account.journey}
                    </div>
                    {account.organizationName && (
                      <div className="account-org">
                        {account.organizationName}
                      </div>
                    )}
                  </div>
                  <div className="account-journey-badge">
                    {journeyLabels[account.journey] || account.journey}
                  </div>
                  <div className="account-arrow">
                    {selecting === account.userId ? (
                      <span className="account-spinner" />
                    ) : (
                      "\u203A"
                    )}
                  </div>
                </button>
              ))}
            </div>

            <div className="account-selector-footer">
              <button className="account-back-link" onClick={onBack}>
                Sign in with a different email
              </button>
            </div>
        </div>
      </div>
    </div>
  );
};

export default AccountSelector;
